import axios from 'axios';

// ─────────────────────────────────────────────────────────────
// Axios instance
// All API calls go through this single instance
// baseURL points to our Express backend on port 5000
// ─────────────────────────────────────────────────────────────
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds — fail fast if backend is down
});

// ─────────────────────────────────────────────────────────────
// REQUEST INTERCEPTOR
// Runs before every API call is sent
// Reads JWT token from localStorage and adds to Authorization header
// This is what the backend protect middleware reads:
//   req.headers.authorization → 'Bearer eyJhbG...'
// ─────────────────────────────────────────────────────────────
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('rbpms_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ─────────────────────────────────────────────────────────────
// RESPONSE INTERCEPTOR
// Runs after every API response is received
// Handles global errors — especially 401 (token expired/revoked)
// ─────────────────────────────────────────────────────────────
api.interceptors.response.use(
  // Success — pass response through unchanged
  (response) => response,

  // Error — handle globally
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or session revoked by admin
      // Clear stored credentials and redirect to login
      localStorage.removeItem('rbpms_token');
      localStorage.removeItem('rbpms_user');
      // Only redirect if not already on login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;